import { useEffect, useRef } from "react";

export default function PatternHoverEffect() {
  const fieldRef = useRef(null);

  useEffect(() => {
    const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!finePointer.matches) return undefined;

    const field = fieldRef.current;
    if (!field) return undefined;

    const pointer = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const follower = { ...pointer };
    let active = false;
    let raf = 0;

    const animate = () => {
      follower.x += (pointer.x - follower.x) * 0.16;
      follower.y += (pointer.y - follower.y) * 0.16;

      field.style.setProperty("--hover-x", `${follower.x}px`);
      field.style.setProperty("--hover-y", `${follower.y}px`);
      field.classList.toggle("is-active", active);

      raf = window.requestAnimationFrame(animate);
    };

    const handleMove = (event) => {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      active = !event.target.closest(".form-card");
    };

    const handleLeave = () => {
      active = false;
    };

    window.addEventListener("mousemove", handleMove, { passive: true });
    document.documentElement.addEventListener("mouseleave", handleLeave);
    raf = window.requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", handleMove);
      document.documentElement.removeEventListener("mouseleave", handleLeave);
      window.cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={fieldRef}
      className="pattern-hover-field"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL || ""}/cream-pattern-seamless-hover-v2.svg)`,
      }}
      aria-hidden="true"
    />
  );
}
